/* istanbul ignore file */
import { useState } from 'react';
import useContractRequestService from 'domain/sales/opportunity/presale/contract/shared/contractRequestService';
import { CreateForm } from 'framework/form';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import ContractRequestForm from 'domain/sales/opportunity/presale/contract/form/ContractRequestForm';
import BeforeSubmitContractRequestModal from 'domain/sales/opportunity/presale/contract/shared/modal/BeforeSubmitContractRequestModal';
import { useOpportunityId } from 'domain/shared/opportunity';
import { usePresaleOutputService } from 'domain/shared/presale';
import { useAsyncValue } from 'framework/utils';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';

const CreateContractRequestForm = ({ submitFormFunc, onCancel, ...props }: any) => {
  const { getValidationSchema } = useContractRequestService();
  const [modalOpen, setModalOpen] = useState(false);
  const id = useOpportunityId();
  const { getLastPresaleOutput } = usePresaleOutputService();
  const lastPresaleOutput = useAsyncValue(() => getLastPresaleOutput(id));
  const onSubmitAction = lastPresaleOutput ? () => setModalOpen(true) : undefined;
  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  return (
    <CreateForm
      submitFormFunc={async data => {
        const artifactPath = data?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.CONTRACT_REQUEST_DOCUMENT);
        return submitFormFunc({ ...data, artifactPaths: commitData });
      }}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <CreateTimelineItemLayout onSubmitAction={onSubmitAction} onCancel={onCancel}>
        <BeforeSubmitContractRequestModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
        <ContractRequestForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreateContractRequestForm;
